<template>
  <fieldset class="account__form-section account__form-section--wide">
    <legend class="account__form-section-title">{{ formSection }}</legend>
    <p class="input-group__directions">
      <strong class="weight--bold"
        >URL hijacking protection is on by default on all MotionMail
        accounts.</strong
      >
    </p>
    <p class="input-group__directions">
      This prevents the ability to pass dates and times in plain text to timer
      URL's and requires users to use the API to dynamically change the end date
      and time of a timer. By disabling URL hijacking protection it will allow
      you to pass dates and times in plain via a query string
      (?endDateTime=yyyy-MM-ddTHH:mm:ss) however this would also allow others to
      take your timer URL and insert their own date.
    </p>
    <div
      class="layout--flex-start layout--flex-align-center layout--margin-bottom-md"
    >
      <strong class="layout--margin-right-sm text-size-sm">Protection:</strong>
      <font-awesome-icon
        :icon="!urlHijacking ? 'check' : 'exclamation-circle'"
        class="color--lighter-green text-size-md"
        :class="{ 'color--purple': urlHijacking }"
      />
      <div
        class="layout--margin-left-xs text-size-sm"
        :class="{ 'color--purple': urlHijacking }"
      >
        {{ !urlHijacking ? "Enabled!" : "Disabled" }}
      </div>
    </div>
    <LoadingButton
      :event="toggleProtection"
      :loading="$wait.is('updating url hijacking')"
      :doneLoading="done"
      :label="buttonLabel"
      :loadingLabel="loadingButtonLabel"
      :doneLoadingLabel="doneLoadingButtonLabel"
    />
  </fieldset>
</template>

<script>
const formSection = "URL Hijacking Protection";

import { mapGetters, mapActions } from "vuex";
import { mapWaitingActions } from "vue-wait";

import LoadingButton from "../../../components/LoadingButton";
import IconAlert from "../../../assets/icons/icon-alert.svg";

export default {
  name: "URLHijackingProtection",
  data() {
    return { done: false, formSection };
  },
  components: { LoadingButton },
  computed: {
    ...mapGetters("account", ["urlHijacking"]),
    buttonLabel: function() {
      if (!this.urlHijacking) {
        return "Disable Protection";
      }
      return "Enable Protection";
    },
    loadingButtonLabel: function() {
      if (!this.urlHijacking) {
        return "Disabling...";
      }
      return "Enabling...";
    },
    doneLoadingButtonLabel: function() {
      if (!this.urlHijacking) {
        return "Done enabling!";
      }
      return "Done disabling!";
    },
  },
  methods: {
    ...mapWaitingActions("account", {
      updateURLHijacking: "updating url hijacking",
    }),
    toggleProtection: function() {
      this.updateURLHijacking(!this.urlHijacking).then(() => {
        this.done = true;
      });
    },
  },
};
</script>

<style></style>
